import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { Observable } from 'rxjs';
import { NavigationService, ResponsiveService } from '@frk/eds-components';
import { HttpClient } from '@angular/common/http';

import {
  ExactMatch,
  FundThumbnail,
  FundItem,
} from '@search/interfaces/search.interface';
import { GeneralService } from './sections/general/general.service';

import { TranslateService } from '@shared/translate/translate.service';
@Component({
  selector: 'ft-exact-match',
  templateUrl: './exact-match.component.html',
  styleUrls: ['./exact-match.component.scss'],
})
export class ExactMatchComponent implements OnInit {
  @Input() exactMatch: ExactMatch;
  /**
   * angular device detection
   */
  isHandheld$: Observable<boolean>;

  disclaimer =
    'The funds listed are for informational purposes only and should not be considered individual investment advice or a recommendation to invest.';

  fundsThumbnails: FundThumbnail[] = [
    {
      title: 'Title 1',
      titleLink: '/title1',
      body:
        'July 17th, 2020  |  Insights <br />word searched for will be <b>bolded XXX</b> here. For example Emerging Markets Inco...',
      docTypeSrc: 'assets/icons/ft-global-icon-ft-thinks.svg',
      ctaText: 'some ctatext 1',
      viewMore: 'View more ',
    },
    {
      title: 'Title 2',
      titleLink: '/title2',
      body:
        'July 17th, 2020  |  Insights <br />word searched for will be bolded here. For example Emerging Markets Inco...',
      docTypeSrc: 'assets/icons/ft-global-icon-ft-thinks.svg',
      ctaText: 'some ctatext 2',
      viewMore: 'View more ',
    },
    {
      title: 'Title 3',
      titleLink: '/title3',
      body:
        'July 17th, 2020  |  Insights <br />word searched for will be bolded here. For example Emerging Markets Inco...',
      docTypeSrc: 'assets/icons/ft-global-icon-ft-thinks.svg',
      ctaText: 'some ctatext 3',
      viewMore: 'View more ',
    },
  ];

  fundItems: FundItem[] = [
    {
      fundName: 'Templeton <strong>Emerging Markets</strong> Fund - 911 EMF',
      fundFamily: 'Multi-Asset',
      fundLink: '/somelink_911_EMF',
    },
    {
      fundName:
        'Templeton <strong>Emerging Markets</strong> Balanced Fund - 011 <strong>EMF</strong>',
      fundFamily: 'Multi-Assets',
      fundLink: '/somelink_911_EMF',
    },
  ];

  fundItemsGeneral: FundItem[] = [
    {
      fundName: 'Templeton <strong>Emerging Markets</strong> Fund - 911 EMF',
      fundFamily: 'Multi-Asset',
      fundLink: '/somelink_911_EMF',
    },
    {
      fundName:
        'Templeton <strong>Emerging Markets</strong> Balanced Fund - 011 <strong>EMF</strong>',
      fundFamily: 'Multi-Assets',
      fundLink: '/somelink_911_EMF',
    },
    {
      fundName:
        'Templeton <strong>Emerging Markets</strong> Balanced Fund - 011 <strong>EMF</strong>',
      fundFamily: 'Multi-Assets',
      fundLink: '/somelink_911_EMF',
    },
  ];

  constructor(
    public cd: ChangeDetectorRef,
    protected http: HttpClient,
    protected translateService: TranslateService,
    protected navigationService: NavigationService,
    public responsiveService: ResponsiveService
  ) {}

  ngOnInit(): void {
    this.isHandheld$ = this.responsiveService.isHandheld$();
  }
}
